import { render, staticRenderFns } from "./Shows.vue?vue&type=template&id=a5941090&scoped=true&"
import script from "./Shows.vue?vue&type=script&lang=js&"
export * from "./Shows.vue?vue&type=script&lang=js&"
import style0 from "./Shows.vue?vue&type=style&index=0&id=a5941090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5941090",
  null
  
)

export default component.exports